var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6917 13.1718C3.35289 12.4286 3.35289 11.5714 3.6917 10.8282C5.26 7.38843 8.70785 5 12.709 5C16.7102 5 20.1581 7.38843 21.7264 10.8282C22.0652 11.5714 22.0652 12.4286 21.7264 13.1718C20.1581 16.6116 16.7102 19 12.709 19C8.70785 19 5.26 16.6116 3.6917 13.1718Z",
    stroke: "#464646",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6848 12C15.6848 13.6569 14.3525 15 12.709 15C11.0656 15 9.73332 13.6569 9.73332 12C9.73332 10.3431 11.0656 9 12.709 9C14.3525 9 15.6848 10.3431 15.6848 12Z",
    stroke: "#464646",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 5L6.00008 19",
    stroke: "#464646",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/close_eye.4651f5556253b076fe414845fe5272cb.svg";
export { ForwardRef as ReactComponent };